const imageGallery = (state = {}, action) => {
    switch (action.type) {
        case 'IMAGEGALLERY_DATA_LOADED' : 
            return{
            ...state,
            imageGalleryData : action.payload
            }
        default:
            return state
        }
  }
  export default imageGallery